import ApiClient from './client';



const path = require('path');



  class PersonalDataAPI extends ApiClient {
    
    async postPersonalDataDemand() {
      const url = path.join(`${this.PERSONAL_DATA_URL}`, 'demands/');
      const response = await this.post(
        url,
        null
      );
      if (response.status === 200) {
        return response.data;
      }
      return false;
    }

  async getPersonalDataDemands() {
    const url = path.join(`${this.PERSONAL_DATA_URL}`, 'demands/');
    const response = await this.get(url);
    if (response.status === 200) {
      return response.data;
    }
    return false;
  }

  // async downloadPersonalData(url) {
  //   const response = await axios.get(
  //     url,
  //     {
  //       responseType: 'blob',
  //       ...DEV_AUTH && { auth: AUTH }
  //     }
  //   );
  //   if (response.status === 200) {
  //     return response.data;
  //   }
  //   return false;
  // }
}
const personalDataAPI = new PersonalDataAPI();
export default personalDataAPI;
